/** Client-side money helpers. Amounts are integer paise from the API; users type rupees. */
export function inr(p: number): string {
  const neg = p < 0, abs = Math.abs(p), r = String(Math.floor(abs / 100)), f = String(abs % 100).padStart(2, "0");
  const g = r.length <= 3 ? r : r.slice(0, -3).replace(/\B(?=(\d{2})+(?!\d))/g, ",") + "," + r.slice(-3);
  return `${neg ? "-" : ""}₹${g}.${f}`;
}
export function toPaise(s: string): number | null {
  const t = s.replace(/[₹,\s]/g, "");
  if (!/^\d{1,9}(\.\d{1,2})?$/.test(t)) return null;
  const [a, b = ""] = t.split(".");
  return Number(a) * 100 + Number(b.padEnd(2, "0"));
}
export const rupees = (p: number) => (p / 100).toFixed(p % 100 ? 2 : 0);
